/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FlexRow, FlexCol } from 'sarsaparilla';
import RenderIf from '../utils/JSXUtils';
import { formatPrice } from '../utils';

const Line = {
    description: PropTypes.string,
    quantity: PropTypes.string,
    title: PropTypes.string,
    value: PropTypes.number,
};

export default class LEGACY_CostsTable extends PureComponent {
    static defaultProps = {
        showNoLinesText: false,
    };

    static propTypes = {
        attendeeInfo: PropTypes.node,
        lines: PropTypes.arrayOf(PropTypes.shape(Line)).isRequired,
        total: PropTypes.shape(Line).isRequired,
        ariaLabel: PropTypes.string,
        showNoLinesText: PropTypes.bool,
    };

    static renderLine = (line, attendeeInfo, ariaLabel) => {
        const { title, description, value } = line;
        if (!value) return null;

        const cost = formatPrice(value);
        const totalCost = title === 'Total Cost';
        const subTotal = title === 'Subtotal';

        let className = totalCost ? 'parkpass-costs-table-total-cost' : '';
        if (subTotal) className = 'parkpass-costs-table-subtotal';
        let aria = `${title}: ${cost}`;
        if (ariaLabel) {
            aria = `${ariaLabel} ${aria}`;
        }
        return (
            <FlexRow
                hasGutters={false}
                key={title}
                className={`parkpass-costs-table-item-wrap ${className}`}
            >
                <FlexCol xs={6} md={8} xl={6} className="parkpass-costs-table-name">
                    {title}
                    {RenderIf(description)(<span>{description}</span>)}
                    {attendeeInfo && (
                        <div className="parkpass-reservation-summary-attendee-info-wrap">
                            {attendeeInfo}
                        </div>
                    )}
                </FlexCol>
                <FlexCol
                    aria-label={aria}
                    role="complementary"
                    xs={6}
                    md={4}
                    xl={6}
                    className="parkpass-costs-table-cost"
                >
                    {cost}
                </FlexCol>
            </FlexRow>
        );
    };

    render() {
        const { attendeeInfo, lines, total, showNoLinesText, ariaLabel } = this.props;

        return (
            <div className="parkpass-costs-table">
                {lines.map((line, index) =>
                    LEGACY_CostsTable.renderLine(line, index ? null : attendeeInfo)
                )}
                {showNoLinesText && (
                    <p>
                        No passes have been selected. Please choose how many passes you
                        will need for this trip.
                    </p>
                )}
                {LEGACY_CostsTable.renderLine(total, null, ariaLabel)}
            </div>
        );
    }
}

// cspell:ignore parkpass
